let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fXOfr")).then(() => parcelRequire('aslEf'));